import { render, staticRenderFns } from "./UserProviderTab.vue?vue&type=template&id=6a204794&scoped=true&"
import script from "./UserProviderTab.vue?vue&type=script&lang=ts&"
export * from "./UserProviderTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a204794",
  null
  
)

export default component.exports